import { computed, observable } from "mobx";
import NaturalPerson from "./naturalPerson";
import LegalPerson from "./legalPerson";
import { Type } from "class-transformer";

export default class VehicleOperator {
  @observable
  isLegalPerson = false;

  @Type(() => NaturalPerson)
  @observable
  naturalPerson?: NaturalPerson = new NaturalPerson();

  @Type(() => LegalPerson)
  @observable
  legalPerson?: LegalPerson = new LegalPerson();

  /*
   * True = Provozovatel je jiný než osoba oznamovatel - je ním zastoupen
   * False = Provozovatel je stejný jako oznamnovatel
   */
  @computed
  get _isRepresentedByProxy() {
    return (!this.isLegalPerson && this.naturalPerson!.isRepresentedByProxy) || this.isLegalPerson;
  }
}
